import { Breakpoint, Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FC } from 'react';

import { IconTheme, IconType } from 'src/components/icons';
import { PictureProps } from 'src/components/picture';
import { i18n } from 'src/i18n';

import {
  StyledButton,
  StyledContainer,
  StyledContent,
  StyledImage,
  StyledItemContainer,
  StyledQuantityLabel,
  StyledIcon,
} from './cart-desktop-item.styled';

interface Props {
  onRemove: () => void;
  title: string;
  quantity: number;
  image: PictureProps;
}

export const CartDesktopItem: FC<Props> = (props) => {
  const { onRemove, title, quantity, image } = props;

  return (
    <StyledContainer>
      <StyledItemContainer>
        <StyledImage {...image} />
        <StyledContent>
          <Typography variant="paragraph3" component="p" maxBreakpoint={Breakpoint.TABLET}>
            {title}
          </Typography>
          <StyledItemContainer>
            <StyledQuantityLabel variant="paragraph3" component="p" maxBreakpoint={Breakpoint.TABLET}>
              {i18n.component.cart.quantity}
            </StyledQuantityLabel>
            <Typography variant="paragraph3" component="p" maxBreakpoint={Breakpoint.TABLET}>
              {quantity}
            </Typography>
          </StyledItemContainer>
        </StyledContent>
        <StyledButton onClick={onRemove}>
          <StyledIcon iconTheme={IconTheme.DARK} iconType={IconType.BIN} />
        </StyledButton>
      </StyledItemContainer>
    </StyledContainer>
  );
};
